<script>
export let header;
export let subHeader;
export let iconName;
</script>
<style>
.card-title {
    text-align: center;
    font-size: large;
    padding-top:30px;
}
.card-subtitle {
    text-align: center;
}
h4:first-child {
    text-align: center;
    color: #E4562550;
    height : 50px;
}
</style>
<div class="card-body">
  <h4><i class={iconName}></i></h4>
  <h5 class="card-title">{header}</h5>
  <h6 class="card-subtitle mb-2 text-muted">{subHeader}</h6>
</div>
